import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  Button,
  Input
} from "reactstrap";

import { focusOnElemName, handleOTPSend } from "../../../pages/commonFunctions";
import { controls } from "../../../pages/controls";
import { AutocompleteCustom } from "../../FormComponents";
import { setCookie, reversibleHash, socket, RelevantIcon, getCookie, detectBrowser } from "../../oro-module/commonFunctions";
import AutoComponent from "../AutoComponent";
import { fetchData } from "../networkRequests";
import "./styles.css";
import { OTPLogin } from "../auth/Login/OTPLogin";
import JSLogo from "../../../images/js_marathi_logo.png";



const SpinngingGIF = () => {
  return (
    <div className="loading_indicator animated bounce infinite">
      <RelevantIcon icon="download-color" />
    </div>)
}
const WebSearch = (props) => {
  let default_benefi = [{ "title": "Amrutraj Gore", "value": "12/04/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }, { "title": "Tejaswee Gore", "value": "08/09/2022", footer: "description", footer_value: "small value" }];

  let [formstate, setformstate] = useState("search");
  let [lastname, setlastname] = useState("");
  let [firstname, setfirstname] = useState("");
  let [mobile, setusername] = useState("");
  let [message, setmessage] = useState();
  let [password, setpassword] = useState();
  let [otpsent, setotpsent] = useState(false);
  let [isSendingOTP, setisSendingOTP] = useState(false);
  let [accountno, setaccountno] = useState('');
  let [isconfirm, setisconfirm] = useState(false);

  const [width, setWidth] = useState(window.screen.width);

  let [isSearching, setisSearching] = useState(false);
  let [beneficieriesList, setbeneficieriesList] = useState(default_benefi);
  let [beneficieryData, setbeneficieryData] = useState({});



  const handleSingleBene = (item) => {
    setformstate('single_result');
    setbeneficieryData(item);
  }

  const setBenefAcNo = (acno) => {
    if (!NaN(parseInt(acno))) {
      setaccountno(acno);
    }
  }

  const submitAccountNumber = () => {
    // ajax post accountno

    setformstate('submitted');
  }

  const SearchItem = ({ item, cur, totlen, handleNext }) => {
    return (
      <div className={`web_search_result_item `} >
        <div className="row hand" onClick={() => handleNext ? handleNext(item) : false}>
          <div className={`${handleNext ? 'col-sm-11' : 'col-sm-12'}`}>
            <div className="web_search_line_1 row">
              <div className="col-sm-8 title">
                {item.title}
              </div>
              <div className="col-sm-4 value">
                {item.value}
              </div>
            </div>
            <div className="web_search_line_2 row">
              <div className="col-sm-8 title">
                {item.footer}
              </div>
              <div className="col-sm-4 value">
                {item.footer_value}
              </div>
            </div>
          </div>
          {handleNext &&
            <div className="col-sm-1 right_carat_container">
              <div className="right_carat" >
                <RelevantIcon icon="right-carat" />
              </div>
            </div>
          }
        </div>

        {!handleNext &&
          <div className="row">


            <div className="col-lg-12 ">
              <Input
                autoComplete="off"
                placeholder="Account Number (जिल्हा बँकेतील खाते क्रमांक)"
                name="acno"
                onChange={e => setBenefAcNo(e.target.value)}
                style={{ marginTop: 10 }}
                type="text"
                autoFocus="autofocus"
                value={accountno}
              />
            </div>
            <div className="col-lg-12 ">
              <div className="authorization_message">
                By clicking the button below, I authorize JaySahakar to retrieve and transfer the funds to my bank account.
                <br />
                खालील बटणावर क्लिक करून, मी जय सहकार ला माझ्या बँक खात्यात निधी जमा करण्यासाठी अधिकृत करतो.
                {/* I agree to pay a fee of Rs.50 to JaySahakar AFTER getting funds to my account, to cover the costs involved in documentation, printing, co-ordination with the bank and government departments, followup, support, monitoring & reporting etc. */}
              </div>
            </div>
            <div className="col-lg-12" style={{ marginTop: 10 }}>
              <Button
                className="col-sm-12 btn login-btn text-black btn-success btn-md "
                onClick={submitAccountNumber}
              >
                SUBMIT
              </Button>
            </div>
          </div>
        }

        {cur != totlen - 1 &&
          <div className="col-sm-12">
            <hr />
          </div>
        }
      </div>
    )
  }


  const BackButton = () => {
    return (
      <div className="web_search_result">
        <div className="back_button">
          <RelevantIcon onClick={handleBack} className="hand" icon="left-arrow-circle" />
        </div>
      </div>
    )
  }
  const handleSearch = () => {
    setisSearching(true);
    // ajax search
    setTimeout(() => {
      setbeneficieriesList(default_benefi);
      // 
      setisSearching(false);
      setformstate("results");
    }, 2000);

  }

  const handleBack = () => {
    setaccountno('');
    if (formstate == 'results') {
      setformstate("search");
      setbeneficieriesList([]);
    } else if (formstate == 'single_result') {
      setformstate("results");
      setbeneficieryData({});
    }
  }

  const manuallyClickOTPBtn = (e) => {
    if (e.key === 'Enter') {
      if (!mobile) {
        setmessage("enter mobile number");
        return false;
      } else {
        handleOTPSend();
      }
    }
  }


  let taluka_component = { ...controls['autoComplete']({ tab: "general", disableSearch: true, "label": "Taluka (तालुका)*", controlType: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", isRequired: true, fastpath: "talukas", width: "col-sm-12", style: { height: width < 500 ? 100 : false, fontSize: 40 } })[0] };

  let village_component = { ...controls['autoComplete']({ tab: "general", "label": "Village (गाव)*", controlType: "Village", placeHolder: "Village Code", name: "village_code", isRequired: true, fastpath: "villages", width: "col-sm-12", sendToServer: { sendData: [{ varname: 'taluka.taluka_uid', value: 'taluka_uid' }] }, style: { height: width < 500 ? 100 : false } })[0] };

  return (
    <div className="web_search_container">
      {/* <div className="search_navbar"> </div> */}
      <div className="row col-sm-12">
        <div className="col-lg-3 col-md-1">
        </div>
        {!isSearching &&

          <div className="col-lg-6 col-md-10">
            {formstate == 'search' &&
              <div className="web_search_form_container">
                <div className="js_logo">
                  <img style={{ height: 174, width: 150, marginBottom: 20 }} src={JSLogo} />
                </div>

                <div className="web_search_form row">


                  <div className="col-lg-6">
                    <div className="outside_control_container">
                      <AutoComponent
                        component={taluka_component}
                        liftState={props.liftState}
                        liftGlobalState={props.liftGlobalState}
                        // parentStateGlobal={this.props.parentState}
                        parentState={props.parentState}
                        parentProps={props.parentProps}
                        conditionalRender={true}
                        key={1222}
                        index={1222}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="outside_control_container">
                      <AutoComponent
                        component={village_component}
                        liftState={props.liftState}
                        liftGlobalState={props.liftGlobalState}
                        // parentStateGlobal={this.props.parentState}
                        parentState={props.parentState}
                        parentProps={props.parentProps}
                        conditionalRender={true}
                        key={12222}
                        index={12222}
                      />
                    </div>
                  </div>

                  <div className={`col-lg-6 `}>
                    <Input
                      className={width < 500 ? 'mobile_mode' : ''}
                      autoComplete="off"
                      placeholder="Last Name (आडनाव) *"
                      name="lastname"
                      onChange={e => setlastname(e.target.value)}
                      style={{ marginTop: 10 }}
                      type="text"
                      autoFocus="autofocus"
                      value={lastname}
                      onKeyDown={(e) => focusOnElemName("firstname")}
                    />
                  </div>
                  <div className="col-lg-6">
                    <Input
                      className={width < 500 ? 'mobile_mode' : ''}
                      autoComplete="off"
                      placeholder="First Name (नाव)"
                      name="first"
                      onChange={e => setfirstname(e.target.value)}
                      style={{ marginTop: 10 }}
                      type="text"
                      value={firstname}
                      onKeyDown={(e) => focusOnElemName("lastname")}
                    />
                  </div>

                  <div className="col-lg-12" style={{ padding: 0 }}>
                    <OTPLogin labels={{ otp: "ओ.टी.पी. भरा", mobile: "मोबाइल क्रमांक", button: "OTP मिळवा" }} options={{ setusername, setpassword, style: width<500 ? { height: 100, fontSize: 30 } : {} }} setmessage={setmessage} props={props} portal="cfout" />
                  </div>

                  <div className="col-sm-12" style={{ height: message ? 40 : 20 }}>
                    <div className="error-message">{message}</div>
                  </div>

                  <div className="col-lg-12">
                    <Button
                      className="col-sm-12 btn login-btn text-black btn-success btn-lg "
                      onClick={handleSearch}
                      style={ width < 500 ? { height: 100, fontSize: 30 } : {}}
                    >
                      लाभार्थी शोधा
                    </Button>
                  </div>
                </div>
              </div>
            }

            {formstate == 'results' &&
              <div className="web_search_results_container">
                <BackButton />
                <div className="web_search_results">
                  {beneficieriesList.map((beneficiery, idx) => <SearchItem handleNext={handleSingleBene} item={beneficiery} key={idx} cur={idx} totlen={beneficieriesList.length} />)}
                </div>
              </div>
            }

            {formstate == 'single_result' &&
              <div className="web_search_results_container">
                <BackButton />
                <div className="web_search_results">
                  <SearchItem item={beneficieryData} key={0} cur={0} totlen={1} />
                </div>
              </div>
            }

            {formstate == 'submitted' &&
              <div className="web_search_results_container">
                <div>
                  <div className="english_message">
                    Account number has been successfully updated. If it matches the name at the bank then the payment will be processed.
                  </div>
                  <div className="marathi_message">
                    खाते क्रमांक यशस्वीरित्या भरला गेला आहे. बँकेतील नाव लाभार्थ्यांच्या नावाला जुळत असल्यास भुगतान केले जाईल.
                  </div>

                  <div className="col-lg-12" style={{ marginTop: 10 }}>
                    <Button
                      className={`col-sm-12 btn login-btn text-black btn-success btn-md`}
                      style={ width < 500 ? { height: 100, fontSize: 30 } : {}}
                      onClick={() => { setformstate('search'); setbeneficieryData({}); setaccountno(''); }}
                    >
                      Go to Search (लाभार्थी शोधा)
                    </Button>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        {isSearching &&
          <div className="col-lg-6 col-md-10">
            <div style={{ textAlign: "center" }}>
              <SpinngingGIF /><br />
              loading please wait...
            </div>
          </div>
        }

        <div className="col-lg-3 col-md-1">
        </div>
      </div>


      <div style={{ textAlign: "center" }}>
        <img style={{ marginBottom: 20 }} src="https://s3.ap-south-1.amazonaws.com/parbhanidccbank.com/pdcclogo.png" />
      </div>

      <div className="powered-by-container">
        <div className="powered-by">
          © Decision Machines Private Limited
        </div>
      </div>



    </div>
  )

}

export default WebSearch;